import DeviceToggler from './DeviceToggler';

export default DeviceToggler;
